import React from "react";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel
} from "@reach/accordion";
import "@reach/accordion/styles.css";

function InformationAccordionRepeater({
  informationAccordion,
  informationAccordionTitle,
  pageId
}) {
  const backgroundClass =
    pageId === 18 || 14 ? "navy-background" : "very-light-blue-background";

  return (
    <section className={`content ${backgroundClass}`}>
      <div className="eighty-spacer"></div>
      <div className={`content-block clearfix ${backgroundClass}`}>
        <div className="info-accordion-holder">
          {informationAccordionTitle ? (
            <>
              <div className="centered-title-holder">
                <h3>{informationAccordionTitle} </h3>
              </div>
              <div className="eighty-spacer"></div>
            </>
          ) : null}
          <Accordion collapsible>
            {informationAccordion.length
              ? informationAccordion.map((cat, index) => (
                  <AccordionItem key={index}>
                    <div
                      className={`info-accordion-container ${backgroundClass}`}
                    >
                      <div className="info-sub-heading-holder">
                        <AccordionButton className="info-sub-heading">
                          {cat.informationSubHeading}
                          <div className="white-mango-status-icon info-plus"></div>
                        </AccordionButton>
                      </div>
                    </div>
                    <AccordionPanel className="info-text-link-container">
                      <div
                        className="info-text"
                        dangerouslySetInnerHTML={{
                          __html: cat.informationText
                        }}
                      />
                      {cat.informationLink ? (
                        <div className="info-link">
                          <a href={cat.informationLink}>Learn More</a>
                        </div>
                      ) : null}
                    </AccordionPanel>
                  </AccordionItem>
                ))
              : null}
          </Accordion>
        </div>
        <div className="one-hundred-spacer"></div>
      </div>
    </section>
  );
}

export default InformationAccordionRepeater;
